import { createStore } from 'vuex'

export default createStore({
  state: {
    headerChangeCounter: 0,
    textChangeCounter: 0,
    buttonChangeCounter: 0,
    message: '',
    headerText: '',
    bodyText: '',
    buttonText: '',
    buttonSizeHeight: 100,
    buttonSizeWidth: 400,
    imageRatioValues: { width: 3000, height: 3400 },
    imageItem: {
      image: null,
      imageUrl: null
    },
    canvasImage: null,
    fontsCollection: [
      'Arial',
      'Times New Roman',
      'Helvetica',
      'Times',
      'Courier New',
      'Verdana',
      'Courier',
      'Arial Narrow',
      'Candara',
      'Calibri',
      'Cambria',
      'Garamond',
      'Perpetua',
      'Brush Script MT',
      'Bookman old style',
      'Palatino Linotype'
    ],
    fontStyles: ['normal', 'bold', 'italic'],
    selectedHeaderFontValues: {
      fontFamily: 'Arial',
      fontSize: 48,
      fontStyle: 'normal',
      fontColor: '#000000',
      shadowIntensity: 0
    },
    selectedTextFontValues: {
      fontFamily: 'Arial',
      fontSize: 28,
      fontStyle: 'normal',
      fontColor: '#000000',
      shadowIntensity: 0
    },
    selectedButtonValues: {
      fontFamily: 'Calibri',
      fontColor: '#FFFFFF',
      fontStyle: 'normal',
      buttonColor: '#607077'
    }
  },
  mutations: {
    changeImage(state, file) {
      state.imageItem.image = file
      state.imageItem.imageUrl = URL.createObjectURL(file)
    },
    insertImage(state) {
      function calculateAspectRatio(width, height, maxWidth, maxHeight) {
        let ratio = [maxWidth / width, maxHeight / height]
        ratio = Math.min(ratio[0], ratio[1])

        return { width: width * ratio, height: height * ratio }
      }

      const image = new Image()
      image.src = state.imageItem.imageUrl
      image.onload = () => {
        let ratioVals = calculateAspectRatio(
          image.width,
          image.height,
          state.imageRatioValues.width,
          state.imageRatioValues.height
        )
        image.width = ratioVals.width
        image.height = ratioVals.height
        state.canvasImage = image
      }
    },
    clearImageUrl(state) {
      state.imageItem.imageUrl = null
      state.imageItem.image = null
      state.canvasImage = null
      state.selectedHeaderFontValues = {
        fontFamily: 'Arial',
        fontSize: 48,
        fontStyle: 'normal',
        fontColor: '#000'
      }
    },
    setSelectedHeaderFontValues(state, vals) {
      if (typeof vals === 'object' && vals !== null) {
        Object.assign(state.selectedHeaderFontValues, vals)
        state.headerChangeCounter += 1
      }
    },
    setSelectedTextFontValues(state, vals) {
      if (typeof vals === 'object' && vals !== null) {
        Object.assign(state.selectedTextFontValues, vals)
        state.textChangeCounter += 1
      }
    },
    setSelectedButtonValues(state, vals) {
      if (typeof vals === 'object' && vals !== null) {
        Object.assign(state.selectedButtonValues, vals)
        state.buttonChangeCounter += 1
      }
    },
    setButtonSizeHeight(state, val) {
      state.buttonSizeHeight = val
      state.buttonChangeCounter += 1
    },
    setButtonSizeWidth(state, val) {
      state.buttonSizeWidth = val
      state.buttonChangeCounter += 1
    },
    resetHeaderFont(state) {
      state.selectedHeaderFontValues = {
        fontFamily: 'Arial',
        fontSize: 48,
        fontStyle: 'normal',
        fontColor: '#000000',
        shadowIntensity: 0
      }
      state.headerChangeCounter = 0
      // state.headerText = ''
    },
    resetTextFont(state) {
      state.selectedTextFontValues = {
        fontFamily: 'Arial',
        fontSize: 28,
        fontStyle: 'normal',
        fontColor: '#000000',
        shadowIntensity: 0
      }
      state.textChangeCounter = 0
      // state.bodyText = ''
    },
    resetButtonValues(state) {
      state.selectedButtonValues = {
        fontFamily: 'Calibri',
        fontStyle: 'normal',
        fontColor: '#FFFFFF',
        buttonColor: '#607077'
      }
      state.buttonSizeHeight = 100
      state.buttonSizeWidth = 400
      state.buttonChangeCounter = 0
    },
    resetAllToDefaults(state) {
      // Reset all text content
      state.headerText = ''
      state.bodyText = ''
      state.buttonText = ''

      // Reset all change counters
      state.headerChangeCounter = 0
      state.textChangeCounter = 0
      state.buttonChangeCounter = 0

      // Reset header font values
      state.selectedHeaderFontValues = {
        fontFamily: 'Arial',
        fontSize: 48,
        fontStyle: 'normal',
        fontColor: '#000000',
        shadowIntensity: 0
      }

      // Reset text font values
      state.selectedTextFontValues = {
        fontFamily: 'Arial',
        fontSize: 28,
        fontStyle: 'normal',
        fontColor: '#000000',
        shadowIntensity: 0
      }

      // Reset button values
      state.selectedButtonValues = {
        fontFamily: 'Calibri',
        fontColor: '#FFFFFF',
        fontStyle: 'normal',
        buttonColor: '#607077'
      }
      state.buttonSizeHeight = 100
      state.buttonSizeWidth = 400

      // Reset image
      state.imageItem.image = null
      state.imageItem.imageUrl = null
      state.canvasImage = null

      // Reset image ratio to desktop
      state.imageRatioValues = { width: 3000, height: 3400 }
    },
    updateHeader(state, value) {
      state.headerText = value
    },
    updateBody(state, value) {
      state.bodyText = value
    },
    updateButton(state, value) {
      state.buttonText = value
    },
    handleImageSizeChange(state, type) {
      if (type == 'tablet') {
        state.imageRatioValues = { width: 1700, height: 2000 }
        this.commit('insertImage')
      } else if (type == 'mobile') {
        state.imageRatioValues = { width: 900, height: 1200 }
        this.commit('insertImage')
      } else {
        state.imageRatioValues = { width: 3000, height: 3400 }
        this.commit('insertImage')
      }
    }
  },
  actions: {},
  modules: {}
})
